<!-- Post -->
<div class="wrapper">
    <div class="main-card">
      <div class="cards" >
        
        <div class="card">
          <div class="content">
            <!--New Cards -->

            
            
            
              <div class="row g-0">
                <div class="col-md-4">
                  <!--<img src="http://localhost:9091/Post/{{ post.image }}" alt="Post Picture" style="max-width: 100%; max-height: 600px;" >-->
                  <img src="http://localhost:9091/Post/{{ post.image }}" alt="Post Picture" style="max-width: 100%; max-height: 600px;" alt="Post Picture" style="max-width: 100%; max-height: 600px; margin-top: 30px; border-radius: 30px; -webkit-box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.2);
                  box-shadow: 0 1rem 2rem rgba(0, 0, 0, 0.2);" >
                </div>
                <div class="col-md-8">
                  <div class="card-body">
                    <h5 class="card-title"style="font-style: Poppins;">{{post.titre}}</h5>
                    <p class="card-text">{{post.description}}</p><br>
                    <p>Want to reach the owner by Social media ? </p>
                    <a class="btn btn-primary" style="background-color: #3b5998;" [href]="post.fb" target="_blank" role="button">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-facebook" viewBox="0 0 16 16">
                      <path d="M16 8.049c0-4.446-3.582-8.05-8-8.05C3.58 0-.002 3.603-.002 8.05c0 4.017 2.926 7.347 6.75 7.951v-5.625h-2.03V8.05H6.75V6.275c0-2.017 1.195-3.131 3.022-3.131.876 0 1.791.157 1.791.157v1.98h-1.009c-.993 0-1.303.621-1.303 1.258v1.51h2.218l-.354 2.326H9.25V16c3.824-.604 6.75-3.934 6.75-7.951z"/>
                    </svg></a>       
                    <a class="btn btn-primary" style="background-color: #ac2bac;" [href]="post.insta" target="_blank" role="button" >
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-instagram" viewBox="0 0 16 16">
              <path d="M8 0C5.829 0 5.556.01 4.703.048 3.85.088 3.269.222 2.76.42a3.917 3.917 0 0 0-1.417.923A3.927 3.927 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297.04.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.916 3.916 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.926 3.926 0 0 0-.923-1.417A3.911 3.911 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0h.003zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046.78.035 1.204.166 1.486.275.373.145.64.319.92.599.28.28.453.546.598.92.11.281.24.705.275 1.485.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.28.11-.704.24-1.485.276-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.478 2.478 0 0 1-.92-.598 2.48 2.48 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485-.038-.843-.046-1.096-.046-3.233 0-2.136.008-2.388.046-3.231.036-.78.166-1.204.276-1.486.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276.738-.034 1.024-.044 2.515-.045v.002zm4.988 1.328a.96.96 0 1 0 0 1.92.96.96 0 0 0 0-1.92zm-4.27 1.122a4.109 4.109 0 1 0 0 8.217 4.109 4.109 0 0 0 0-8.217zm0 1.441a2.667 2.667 0 1 1 0 5.334 2.667 2.667 0 0 1 0-5.334z"/>
            </svg>
            </a> 
            <a class="btn btn-primary" style="background-color: #0082ca;" [href]="post.linkedin"  target="_blank"role="button"
            ><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-linkedin" viewBox="0 0 16 16">
              <path d="M0 1.146C0 .513.526 0 1.175 0h13.65C15.474 0 16 .513 16 1.146v13.708c0 .633-.526 1.146-1.175 1.146H1.175C.526 16 0 15.487 0 14.854V1.146zm4.943 12.248V6.169H2.542v7.225h2.401zm-1.2-8.212c.837 0 1.358-.554 1.358-1.248-.015-.709-.52-1.248-1.342-1.248-.822 0-1.359.54-1.359 1.248 0 .694.521 1.248 1.327 1.248h.016zm4.908 8.212V9.359c0-.216.016-.432.08-.586.173-.431.568-.878 1.232-.878.869 0 1.216.662 1.216 1.634v3.865h2.401V9.25c0-2.22-1.184-3.252-2.764-3.252-1.274 0-1.845.7-2.165 1.193v.025h-.016a5.54 5.54 0 0 1 .016-.025V6.169h-2.4c.03.678 0 7.225 0 7.225h2.4z"/>
            </svg>            
                      </a><br><br>
                      <p>Mobile : {{post.numtlf}}</p><br>
                    
                    
                    <!--Show only when the ba9chich not empty -->
                        <h5 class="card-title" *ngIf="post.ba9chich">Donation</h5>
                        
                        <p *ngIf="post.ba9chich">
                          you can support this project by Donation via this link
                          <a target="_blank" href="{{ post.ba9chich }}">ba9chich</a>
                        </p>
                    <br>
                        <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
                        <small style="transform:translateY(-300%);font-style: Poppins;">Published on : {{post.date}} by {{ post.user.nom }} {{ post.user.prenom }} </small>
      
                  
                </div>
              </div>
            </div>
    
    
         

    
            <a style="margin-left: 80%; color: #2D2F44; font-size: x-large; margin-bottom: -28px;"  href="/home/posts/post" (click)="likePost()">
              <fa-icon [icon]="faComment"  class="material-icons"></fa-icon>
            </a>
            <p style="margin-left: 88%; color: #2D2F44;"> {{nComment}} Comments </p>
    
    
    
            <a style="color: #2D2F44; margin-top: -45px; margin-bottom: 17px; margin-left: -92%; font-size: x-large;" [ngClass] = "{'is-active' : hamClick}"  href="/home/posts/post" (click)="likePost()">
              <fa-icon style="color: #2D2F44;" [icon]="faThumbsUp"  class="material-icons"></fa-icon>
            </a>
            <a class="dislike" style="color: #2D2F44; margin-top: -45px; margin-left: -88%;font-size: x-large;" (click)="dislikePost()"  href="/home/posts/post">
              <fa-icon style="color: #2D2F44;" [icon]="faThumbsDown"  class="material-icons"></fa-icon>
            </a>
            
    
    
            <p style="color: #2D2F44; margin-top: -28px; margin-left: -82%;">{{post.like}} Likes</p>
    
            <br>
            <br>
            <!--Add Comment-->          
            <!--new style-->
          
            
          </div>
        </div>
      </div>
      
     
    </div>
    
    <!--Comments-->
    <!-- <div class="container2"> -->
   <!-- <div class="main-card"  *ngFor="let com of commentaire">
      <div -->
    
        <div class="row height d-flex justify-content-center align-items-center">
          <div class="col-md-7">
            <div class="card" style="border: 1px solid #2D2F44; border-radius: 30px">
            <div class="p-3">
<div style="margin-left: 30px;">
  <h5>Comments</h5>
              
</div>
<div class="mt-3 d-flex flex-row align-items-center p-3 form-color"  *ngIf="comment" [hidden]="hideCommentform">

  <img class="comPic" src="http://localhost:9091/User/{{ user.profileImage }}" width="40" height="40" class="rounded-circle mr-3">
  <input type="text" class="form-control" placeholder="Enter your comment..."  [(ngModel)]="comment.description" required #description="ngModel">
  <a href="/home/posts/post">
    
    <button  routerLink="/home/posts/post" type="button" class="btn btn-primary btn-sm" (click)="addComment(comment)" [disabled]="description.invalid">Post</button>
  </a>

</div>
  <div class="mt-2">

    <div class="d-flex flex-row p-3" *ngFor="let com of commentaire">

      <img class="comPic" src="http://localhost:9091/User/{{ com.user.profileImage }}" width="40" height="40" class="rounded-circle mr-3">

      <div class="w-100">

        <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex flex-row align-items-center">
              <span class="mr-2"> {{com.user.nom}} {{com.user.prenom}}</span>
              <small class="c-badge">Top Comment</small>
            </div>
            <small>{{com.date}}</small>
      </div>

      <p class="text-justify comment-text mb-0">{{com.description}}</p>

      <div class="d-flex flex-row user-feed">

        <span class="wish"><i class="fa fa-heartbeat mr-2"></i>24</span>
        <span class="ml-3"><i class="fa fa-comments-o mr-2"></i>Reply</span>
       <span class="ml-3">
        <a href="/home/posts/post" (click)="deleteCommentaire(com._id)" [hidden]="hideSupp(com.user._id)"><fa-icon [icon]="faTrash"  class="material-icons" style ="color: red;"></fa-icon></a>
       </span> 
       
        
      </div>
      
    </div>
    

  </div>



  
</div>

</div>
             
          </div>
</div>
</div>
    </div>
    <!-- </div> -->
    <!--Respons-->
    <!--<div class="main-card" *ngFor="let rep of listReponse">
      <div class="cards" >
        <div class="card">
          <div class="content">
            <li style="list-style-type: none; float: left; margin-left: -85%; margin-top: -20px;" >
              <img src="http://localhost:9091/User/{{ rep.user.profileImage }}" style="width: 30px; height: 30px; border-radius: 50%; border: 2px solid #2D2F44; display: inline;" alt="profile Image"/>
                <a class="nav-link">
                  <i class="ion-md-power" style="margin-left: -60%;"></i> {{rep.user.nom}} {{rep.user.prenom}}
                </a>
                <br>
            </li>
            <div class="details">
              <small>Published on : {{rep.date}}</small>
            <div class="name">
              <p>{{rep.description}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>-->
    
    <!--<div class="main-card">
      <div class="cards" >
        <div class="card">
          <div class="content">
            <li style="list-style-type: none; float: left; margin-left: -85%; margin-top: -20px;">
              <img src="http://localhost:9091/User/{{ user.profileImage }}" style="width: 30px; height: 30px; border-radius: 50%; border: 2px solid #2D2F44; display: inline;" alt="profile Image"/>
              <a class="nav-link" style="font-weight: bold; display: inline; color: black; margin-left: 0px; margin-bottom: 10px;">
                <i class="ion-md-power"></i> {{user.nom}} {{user.prenom}}
              </a>
              <br>
            </li>
            <br>
            <div class="form-group" *ngIf="comment">
              <input style="width: 90%; height: 40px; margin-left: 0px;" type="text" class="form-control" placeholder="Comment"[(ngModel)]="comment.description" required #description="ngModel"/>
              <button  class="btn btn-primary" style="height: 40px; margin-left: -20%;" (click)="addComment(comment)"> Send </button>
            </div>
            <br>
          </div>
        </div>
      </div>
    </div>-->
    
    
    